import { postApiEmbeddingCollectionFindCollectionsTags, TagsConfig } from "@/API";
import { ActionIcon, Text, Button, Group, Modal, Paper, Stack, Textarea, Autocomplete } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import { PropsWithChildren, useEffect, useState } from "react";

export function TagsConfigEditButton(props: { config?: TagsConfig, onChange?: (config: TagsConfig) => void, workspaceId: string, embeddingCollectionId?: string[] } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const form = useForm<TagsConfig>({
        initialValues: props.config,
        validate: {
            tagDataConfigs: {
                name: v => !v ? "必須要有Tag名稱" : null
            }
        }
    });
    const [tagsCandidates, setTagsCandidates] = useState<string[]>([])
    useEffect(() => {
        if (opened) {
            postApiEmbeddingCollectionFindCollectionsTags(props.embeddingCollectionId ?? [], { workspaceId: props.workspaceId }, {
                headers: { "Content-Type": "application/json" }
            }).then(x => {
                setTagsCandidates(x.data ?? [])
            })
            if (props.config) form.setValues(props.config)
            else form.reset()
        }
    }, [opened])

    const tags = form.getValues().tagDataConfigs?.map((item, index) => (
        <Paper key={index} withBorder shadow="sm" p="md">
            <Stack mt="xs">
                <Autocomplete
                    label="Tag名稱"
                    description="需要添加prompt的tag"
                    placeholder="Tag name"
                    withAsterisk
                    data={tagsCandidates}
                    {...form.getInputProps(`tagDataConfigs.${index}.name`)}
                />
                <Textarea
                    label="Tag prompt"
                    description="擁有此tag的資料最上方會添加此prompt"
                    placeholder="Tag prompt"
                    maxRows={5}
                    autosize
                    {...form.getInputProps(`tagDataConfigs.${index}.prompt`)}
                />
                <ActionIcon color="red" onClick={() => form.removeListItem('tagDataConfigs', index)}>
                    <IconTrash size={16} />
                </ActionIcon>
            </Stack>
        </Paper>
    ));

    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="Tags設定" size="xl">
            <form onSubmit={form.onSubmit((values) => {
                props.onChange?.(values)
                close()
            })}>
                <Text>
                    Tag prompt設定
                </Text>
                <Text size="sm" c="gray">
                    當資料被搜尋到時，會自動把該資料擁有的Tag對應的prompt放入資料的最上方
                </Text>
                <Stack gap={10} mt="md">
                    {tags}
                </Stack>
                <ActionIcon color="green" mt="md" onClick={() =>
                    form.insertListItem('tagDataConfigs', {})
                }>
                    <IconPlus size={16} />
                </ActionIcon>
                <Group justify="flex-end" mt="md">
                    <Button type="submit">保存</Button>
                </Group>
            </form>
        </Modal>
    </>
}